// extracted by mini-css-extract-plugin
export default {"toggle-items":"lsf-toggle-items","toggle-items_big":"lsf-toggle-items_big","toggle-items__item":"lsf-toggle-items__item","toggle-items__item_active":"lsf-toggle-items__item_active"};